import common from './common.json';

export default {
  "description": "Webエンジニアのじゅんかたです。私について。",
  "cover": "***",
  "paragraph": [
    {
      "title": "作ること、好きです",
      "description": "こんにちは。東京に住んでいる「じゅんかた」と申します。<br>Web制作会社でWebエンジニアとして働いています。<br>このサイトは個人的に作成した私のプロフィールサイトです。<br><br>2005年にWebデザイナーとして入社し、その後フロントエンドとバックエンドの開発、インフラ運用を行ってきました。<br><br>Webに関するあれやこれ、覚えることが尽きないですが、なんだかんだで好きな仕事だと、このサイトを作ってる時に改めて思いました。"
    },
    {
      "title": "使うもの",
      "list": common.skill,
    },
    {
      "title": "大切にしてる事",
      "description": "日々の暮らしで大切にしてる事を、素晴らしい偉人達の名言と一緒にご紹介します",
      "quotes": [
        {
          "title": "# 目的と方向性",
          "items": [
            {
              "body": "目的を見つけよ。手段は後からついて来る。",
              "author": "マハトマ・ガンジー"
            },
            {
              "body": "目的と方向性が無ければ、努力と勇気だけでは充分ではない。",
              "author": "ジョン・F・ケネディ"
            }
          ]
        },
        {
          "title": "# 流行を恐れない",
          "items": [
            {
              "body": "最も強い者が生き残るのではなく、最も賢い者が生き延びる訳でもない。唯一生き残るのは、変化に適応できる者である。",
              "author": "チャールズ・ダーウィン"
            }
          ]
        },
        {
          "title": "# 好奇心を大切にします",
          "items": [
            {
              "body": "好奇心は理由があって存在している。",
              "author": "アルベルト・アインシュタイン"
            }
          ]
        },
        {
          "title": "# トライを大切にします",
          "items": [
            {
              "body": "自分ならできると信じれば、もう半分は終わったようなものだ。",
              "author": "セオドア・ルーズベルト"
            }
          ]
        },
        {
          "title": "# やらない事はやりません",
          "items": [
            {
              "body": "不可能なことはしっかり無視して、実際に新しい解決策を構築しなさい。",
              "author": "ラリー・ペイジ"
            }
          ]
        },
        {
          "title": "# ライバルは僕自身です",
          "items": [
            {
              "body": "あなたができると思っていても、あなたができないと思っていても、いずれにしてもあなたは正しい。",
              "author": "ヘンリー・フォード"
            }
          ]
        },
        {
          "title": "# 広い視野で問題を見ます",
          "items": [
            {
              "body": "この世の重要な問題は、それを作りだした時と同じ思考レベルで解決することはできない。",
              "author": "アルベルト・アインシュタイン",
              }
          ]
        },
        {
          "title": "# 日々ほんのわずかでも学び続けます",
          "items": [
            {
              "body": "ただ続けなさい。それさえ守れば誰もがより良くなる。",
              "author": "テッド・ウィリアムズ"
            }
          ]
        },
        {
          "title": "# 大事な事は粘り強く取り組みます",
          "items": [
            {
              "body": "全ての素晴らしい成果には時間を要する。",
              "author": "マヤ・アンジェロウ"
            }
          ]
        },
        {
          "title": "# 遊び心も大切にしたいです",
          "items": [
            {
              "body": "人生は遊びだ。",
              "author": "岡本太郎"
            }
          ]
        },
        {
          "title": "# 健康第一",
          "items": [
            {
              "body": "生きるために食べよ、食べるために生きるな。",
              "author": "ソクラテス"
            }
          ]
        },
        {
          "title": "# 運動します",
          "items": [
            {
              "body": "覚えておけ、ポケットに手を入れたままでは成功へのはしごは上れない。",
              "author": "アーノルド・シュワルツェネッガー"
            }
          ]
        },
        {
          "title": "# 時間を大切にします",
          "items": [
            {
              "body": "1時間の浪費をなんとも思わない人は、人生の価値をまだ発見してはいない。",
              "author": "チャールズ・ダーウィン"
            }
          ]
        }
      ]
    }
  ]
}